<!--
 - Author : wanghongling.
 - Date   : 2019/5/28.
 - File   : jKZDQPersonal.健康证到期人员
 -->

<template>
  <div :class="['jKzdq-personal', getViewPer==='1'?'':'']">
    <layer title="健康证到期人员"
        width="418px"
        padding="10px 20px 8px"
        contPadding="10px 0 0"
        :showMoreTag="list.length>1"
        @showMore="showMore">
      <!--<el-carousel :interval="50000000" :indicator-position="list.length>1?'outside':'none'"-->
          <!--:arrow="list.length>1?'hover':'never'" v-if="getViewPer==='1'">-->
        <!--<el-carousel-item v-for="(item, index) in list" :key="index">-->
          <!--<div :class="['person-list', item.length>1?'':'jsc']">-->
            <!--<div class="person-list-item" v-for="(person, i) in item" :key="i">-->
              <!--<div class="person-list-item-left">-->
                <!--<img :src="person.fileId?(imgUrl+person.fileId):avatar" alt="">-->
              <!--</div>-->
              <!--<div class="person-list-item-right">-->
                <!--<p>-->
                  <!--<span v-if="item.length>1" class="name" :title="person.userName">{{person.userName|filterName}}</span>-->
                  <!--<span v-if="item.length===1" class="name" :title="person.userName">{{person.userName}}</span>-->
                  <!--<span class="res">({{person.departmentName}})</span>-->
                <!--</p>-->
                <!--<p>{{person.endDate}} 到期</p>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</el-carousel-item>-->
        <!--<div class="no-the-data" v-if="list && list.length===0">-->
          <!--<div>-->
            <!--<i class="iconfont icon-content-likes dzi"></i>-->
            <!--<p>暂无健康证到期人员</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</el-carousel>-->
      <!--<el-carousel :interval="5000" :indicator-position="list.length>1?'outside':'none'"-->
          <!--:arrow="list.length>1?'hover':'never'" v-if="!(getViewPer==='1')">-->
      <el-carousel :interval="5000" :indicator-position="list.length>1?'outside':'none'"
          :arrow="list.length>1?'hover':'never'">
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <div :class="['person-list', item.length>2?'':'jsc']">
            <div class="person-list-item" :style="{width:item.length>2?'50%':'65%'}" v-for="(person, i) in item"
                :key="i">
              <div class="person-list-item-left">
                <img :src="person.fileId?(imgUrl+person.fileId):avatar" alt="">
              </div>
              <div class="person-list-item-right">
                <p>
                  <span class="name" :title="person.userName" v-if="item.length>3">{{person.userName|filterName}}</span>
                  <span class="name" :title="person.userName" v-if="item.length<4">{{person.userName}}</span>
                  <span class="res">({{person.departmentName}})</span>
                </p>
                <p>{{person.endDate}} 到期</p>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <div class="no-the-data" v-if="list && list.length===0">
          <div>
            <i class="iconfont icon-content-likes dzi"></i>
            <p>暂无健康证到期人员</p>
          </div>
        </div>
      </el-carousel>
      <transition name="slide-right-fade">
        <people-List class="jkz-pop" :peopleObj="peopleObj" v-show="peopleObj.isMore"></people-List>
      </transition>
    </layer>
  </div>
</template>

<script>
export default {
  name: 'jKZDQPersonal',
  data () {
    return {
      orgId: this.$store.getters.userInfo.orgId,
      imgUrl: this.$store.getters.fileApi,
      avatar: require('../../assets/images/avatar.jpg'),
      list: [],
      peopleObj: {
        title: '健康证到期人员',
        isMore: false,
        list: []
      }
    }
  },
  props: {
    selectOrgId: {}
  },
  watch: {
    getViewPer: {
      handler: function () {
        this.getHealthExpiryList()
      },
      immediate: true,
      deep: true
    },
    selectOrgId: {
      handler(cur) {
        this.orgId = cur
        this.getHealthExpiryList()
      },
      deep: true
    }
  },
  computed: {
    getViewPer() {
      return this.$store.getters.viewList.e001
    }
  },
  methods: {
    /**
     * @Description:显示更多健康证到期人员弹窗
     * @author wanghongling
     * @createDate 2020/4/3
     */
    showMore() {
      this.peopleObj.isMore = !this.peopleObj.isMore
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/20
     * 获取健康证到期人员列表
     */
    getHealthExpiryList() {
      this.$request.pcHealthExpiryListGet({orgId: this.orgId}).then(res => {
        console.log('获取健康证过期人员列表', res)
        if (!this.$utils.isEmptyObject(res)) {
          this.peopleObj.list = res
          // this.list = []
          this.list.length = 0
          let tmpList = res
          // let num = (this.getViewPer === '1') ? 4 : 8
          let num = 4
          for (let i = 0; i < tmpList.length; i += num) {
            this.list.push(tmpList.slice(i, i + num))
          }
        }
      }).catch(e => {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .jKzdq-personal{
    .jkz-pop{
      position: absolute;
      right: 430px;
      top: 0;
      z-index: 2;
      .detail-wrap{
        max-height: 300px !important;
      }
    }
    .layer-wrap{
      position: relative;
    }
    padding-bottom: 15px;
    .person-list{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-top: -5px;
      min-height: 100%;
      &-item{
        width: 50%;
        margin-top: 5px;
        display: flex;
        align-items: center;
        &-left{
          width: 51px;
          height: 51px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          border-radius: 50%;
          border: 1px solid #fff;
          img{
            width: 51px;
            border-radius: 50%;
          }
        }
        &-right{
          padding-left: 10px;
          flex: 1;
          p{
            font-size: 14px;
            color: @lightGrey;
            display: flex;
            flex-wrap: wrap;
            .name{
              font-size: 15px;
              color: @lightBlue;
              padding-right: 8px;
            }
            .res{
              font-size: 14px;
              color: @darkGreen;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
    .jsc{
      justify-content: center;
      align-content: center;
      height: 100%;
    }
    .el-carousel--horizontal {
      /*margin-bottom: -20px;*/
    }
    .el-carousel__container{
      height: 155px;
    }
    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
    .el-carousel__indicators--outside button{
      background-color: #000;
      opacity: 1;
    }
    .el-carousel__indicator.is-active button{
      background-color: #0a8b9c;
    }
    .el-carousel__indicator--horizontal{
      padding: 6px 4px;
    }
  }
  .person{
    .el-carousel__container{
      height: 340px !important;
    }
    .person-list-item{
      margin-top: 15px !important;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/jKZDQPersonal.vue